import { PDFRelatorioDespesasPaginaLinhaProps } from "features/relatorios/typings";
import useRelatorioDespesaPdfColumns from "../hooks/useRelatorioDespesaPdfColumns";
import { PDFLayout } from "ui/components/PDF";
import { PDFTable } from "ui/components/PDF";

function PDFRelatorioDespesasPaginaLinha(
  props: PDFRelatorioDespesasPaginaLinhaProps
) {
  const selectedFields = props.selectedFields;

  const columns = useRelatorioDespesaPdfColumns(selectedFields);

  return (
    <PDFLayout
      orientation="portrait"
      includeDocument={true}
      assinaturas={props.assinaturas}
      headerProps={{
        logo: props?.logo!,
        subTitle: props?.periodo!,
        tenant: props?.nomeTenant!,
        title: "Relatório de despesas",
      }}
      footerProps={{
        tenant: props?.nomeTenant!,
        logo: props?.logoAdm!,
        endereco1: props?.endereco1!,
        endereco2: props?.endereco2!,
      }}
    >
      <PDFTable data={[props.item]} columns={columns} />
    </PDFLayout>
  );
}

export default PDFRelatorioDespesasPaginaLinha;
